import React, {Fragment} from 'react';
import {Icons, Edit, DynamicContainer, List, Popup} from 'components';
import {useEditableList, useField, reject, openPopup} from 'helpers';

export function EditListItems(props) {
  const [ { value }, , { setValue } ] = useField(props);
  const list = useEditableList(value, setValue, 'name');

  return (
    <DynamicContainer>
      <List tiny-gutter>
        { value && value.map(item =>
          <div key={item.id} data-id={item.id}>
            <Edit
              name={item.id}
              placeholder="Enter New Item.."
              setValue={list.setValue}
              status={item.status}
              value={item.name}
              remove={() => setValue(reject(value, ({ id }) => id === item.id))}
              Suffix={Actions}
            />
          </div>
        ) }
      </List>
    </DynamicContainer>
  );
}

function Actions({name, remove}) {
  return (
    <Fragment>
      <Icons.Pencil title="Edit" to={`/lists/items/${name}/`} />
      <Icons.Close className="secondary" onClick={remove}/>
    </Fragment>
  );
}
